import script from "./BackendLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./BackendLayout.vue?vue&type=script&setup=true&lang=js"

import "./BackendLayout.vue?vue&type=style&index=0&id=58981fc4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58981fc4"]])

export default __exports__